import * as api from './index';

export function getWorkOrders(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/work-orders?${queryString}`);
}

export function getWorkOrder(id) {
    return api.get(`/work-orders/${id}`);
}

export function createWorkOrder(workOrder) {
    return api.post('/work-orders', workOrder);
}

export function updateWorkOrder(workOrder) {
    return api.patch(`/work-orders/${workOrder.id}`, workOrder);
}

export function setIsActiveWorkOrder(workOrder, isActive) {
    return api.patch(`/work-orders/${workOrder.id}/isActive`, { isActive });
}

export function softDeleteWorkOrder(workOrder) {
    return api.del(`/work-orders/${workOrder.id}/soft`);
}
